import React from 'react';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FaPlus } from 'react-icons/fa';
import Form from 'react-bootstrap/Form';
import { tr } from 'date-fns/locale';


class FieldAcessControl extends React.Component {

  constructor(props) {
    super(props);
    this.fieldList = [];
    for(let i = 0; i < props.fields.length; i++) {
      this.fieldList.push({ id: props.fields[i].id, value: props.fields[i].fieldKey,
        type: props.fields[i].field_type, label: props.fields[i].label_name });
    }
    const fields = props.value ? props.value : [];
    this.state = { ...this.state, fields };
    if(this.props.onAcessChanged) {
      this.props.onAcessChanged(fields);
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.fieldList = [];
    for(let i = 0; i < props.fields.length; i++) {
      this.fieldList.push({ id: props.fields[i].id, value: props.fields[i].fieldKey,
        type: props.fields[i].field_type, label: props.fields[i].label_name });
    }
    const fields = props.value ? props.value : [];
    this.props.onAcessChanged(fields);
    this.setState({ ...this.state, fields });
  }


  onAdd = field => {
    const fields = [...this.state.fields, { field: field.value, visible: true,
      editable: true, form_mandate: false } ];
    this.props.onAcessChanged(fields);
    this.setState({ ...this.state, fields, show: false });
  }
  onDelete = index => {
    const fields = [ ...this.state.fields ].filter((_, i) => i !== index);
    this.props.onAcessChanged(fields);
    this.setState({ ...this.state, fields });
  }
  
  onChange = (i, type, value) => {
    const fields = [ ...this.state.fields ];
    fields[i][type] = value;
    this.props.onAcessChanged(fields);
    this.setState({ ...this.state, fields });
  }

  render() {
    return (
      <>
        <Modal aria-labelledby="contained-modal-title-vcenter" size="md" className="w-660" 
          centered show={this.state.show}
          onHide={() => this.setState({ ...this.state, show: false})}
          onExit={() => this.setState({ ...this.state, show: false})}>

          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Add Field</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Select className="mr-sm-2"
              onChange={selected => this.onAdd(selected) }
              options={this.fieldList} isSearchable={true} isClearable={true} />
          </Modal.Body>
        </Modal>
        
        <div className="formhead col-md-12">
          <h4>Access Control Field <Button variant="primary" onClick={() => this.setState({ ...this.state, show: true})}><FaPlus />
          </Button></h4>
        </div>

        { this.state.fields.map((field, i) => 
            <div key={`access_${i}`} className="col-md-12 condition-select-div">
              {this.fieldList.find(ietm => ietm.value === field.field).label}
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Form.Check label="Is Visible" checked={field.visible} 
                onChange={event => this.onChange(i, 'visible', event.target.checked )} />
                &nbsp;&nbsp;&nbsp;&nbsp;
              <Form.Check label="Is Editable" checked={field.editable} 
                onChange={event => this.onChange(i, 'editable', event.target.checked )} />
                &nbsp;&nbsp;&nbsp;&nbsp;
              <Form.Check label="Is Form Mandatory" checked={field.form_mandate} 
                onChange={event => this.onChange(i, 'form_mandate', event.target.checked )} />
            </div>
          )
        }
      </>
    );
  }
}
export default FieldAcessControl;